export default "__VITE_ASSET__YHW4TZ2U__"